<div class="admin-maintenance-preview-banner" *ngIf="isMaintenanceMode && !isAdminRoute && !isMaintenanceRoute && isAdminUser">
  <span class="preview-dot"></span>
  <span class="preview-text"><strong>Maintenance Mode Active:</strong> You are browsing user routes with Administrator access.</span>
  <a routerLink="/admin/dashboard" class="preview-btn">Admin Console &rarr;</a>
</div>

<app-offline-page></app-offline-page>
<app-quiz-nav *ngIf="!isMaintenanceMode && !isMaintenanceRoute && showQuizNav"></app-quiz-nav>
<!-- <app-global-loader *ngIf="!isMaintenanceMode"></app-global-loader> -->
<app-toast></app-toast>
<app-maintenance-page *ngIf="showMaintenanceOnRoot"></app-maintenance-page>
<router-outlet *ngIf="!showMaintenanceOnRoot" />

<div class="chat-widget" *ngIf="!isMaintenanceMode && !isMaintenanceRoute && !isAdminRoute">
  <button type="button" class="chat-fab" (click)="toggleChatWidget()" [attr.aria-expanded]="isChatWidgetOpen"
    aria-controls="home-chat-panel" aria-label="Open chat assistant">
    <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"></path>
    </svg>
  </button>

  <div id="home-chat-panel" class="chat-panel" *ngIf="isChatWidgetOpen">
    <button type="button" class="chat-close-btn" (click)="closeChatWidget()" aria-label="Close chat assistant">
      ×
    </button>
    <app-chatting></app-chatting>
  </div>
</div>
